import React from 'react';

export default function Field({ formField, disabled }) {
  const Component = formField.component;

  return (
    <Component
      name={formField.name}
      label={formField.label}
      helperText={formField.helperText}
      options={formField.options}
      type={formField.type}
      variant={formField.variant}
      fullWidth={formField.fullWidth}
      select={formField.select}
      margin={formField.margin}
      other={formField.other}
      disabled={disabled}
    />
  );
}
